// format tt (time for delayed ticketing)
export default function getDTTime(dt) {
  const dtArr = dt.split('/');
  const adt = dtArr[0];
  const mdt = dtArr[1];
  let val = adt;
  if (mdt || adt === '0:0:0') {
    val = mdt;
  }
  const arr = val.split(':');
  return `${arr[0] !== '0' ? arr[0] + ' days' : ''} ${arr[1] !== '0' ? arr[1] + ' hours' : ''} ${
    arr[2] !== '0' ? arr[2] + ' minutes' : ''
  }`;
}
